import FooterEnd from 'comman/component/footerEnd';
import TableComponent from 'comman/component/table';
import { useDebounce } from 'helper/comman';
import { formatPhoneDisplay, normalizePhone } from 'helper/phone';

import { useEffect, useMemo, useState } from 'react';
import { Button, Card, FormGroup, Modal, Spinner } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
  setModalAction,
  setShowModal,
} from 'redux/active-tabs/active-tab.action';
import _isEmpty from 'lodash/isEmpty';
import _flow from 'lodash/flow';
import Papa from 'papaparse';

import { showToast } from 'redux/auth/auth.action';
import gradientDefaultRinger from '../assets/img/gradient_ringer_default.png';
import { ReactComponent as AndroidIcon } from '../assets/svg/android.svg';
import { ReactComponent as AppleIcon } from '../assets/svg/apple.svg';
import { ReactComponent as EditIcon } from '../assets/svg/edit.svg';
import { ReactComponent as OpenNewTabIcon } from '../assets/svg/open-new-tab.svg';
import { ReactComponent as TrashIcon } from '../assets/svg/remove.svg';
import MyDropZoneLogo from '../comman/component/uploadfile.logo';
import Select from 'react-select';

import defaultGallery from '../assets/img/gallery_default.png';

import { ErrorMessage, Field, FieldArray, Form, Formik } from 'formik';
import { PHONE_REG_EXP } from 'helper/constant';
import {
  CHECK_MARK,
  CHECK_MARK_SYMBOL,
  DEFAULT_PREFIX,
  PREFIX_CIRCLE,
  PREFIX_XI,
  optionOneTap,
  optionPrefix,
} from 'helper/constant/contact';
import {
  fetchGalleryDetails,
  getGalleryDetailById,
  updateImage,
  uploadImage,
} from 'helper/galleyHelper';
import { isArray } from 'lodash';
import ReactInputMask from 'react-input-mask';
import { Lightbox } from 'react-modal-image';
import {
  createContactsRCD,
  deleteContactRCD,
  searchRCD,
  updateContactsRCD,
} from 'services/contacts';

import {
  searchContacts,
  deleteContact,
  createContacts,
  updateContacts,
} from '../services/contacts';

import swal from 'sweetalert';
import * as Yup from 'yup';
import useBoolean from 'hooks/useBoolean';
import useExportData from 'hooks/useExportData';
import { allMobileNotification } from 'services/notifyMobile';
import ImageEditorModal from 'container/ImageEditor/ImageEditorModal';
import SelectGallery from '../comman/component/SelectGallery';
import { useGalleryBase64 } from 'hooks/useGalleryBase64';
import { IMAGE_TYPE } from 'helper/constant/gallery';

const initialValues = {
  firstName: '',
  lastName: '',
  phone: [''],
  regions: [],
  prefixName: DEFAULT_PREFIX,
  fullImage: '',
  logo: '',
  fullImageUrl: '',
  logoUrl: '',
  fullImageFile: null,
  logoFile: null,
  linkActionUrl: '',
  linkActionType: 'oneTap',
  // logoImage: initialPreviewScreen.logo,
  // fullImage: initialPreviewScreen.fullImage,
};

function textToBooleanImportField(value) {
  if (!value) return false;

  const trueList = ['1', 'y', 'yes'];

  return trueList.includes(`${value}`.toLocaleLowerCase());
}

const validationSchema = Yup.object().shape({
  firstName: Yup.string().required('FirstName is required'),
  // linkActionUrl: Yup.string().url('1-Tap link must be a valid URL'),
  linkActionUrl: Yup.string().matches(
    /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?/g,
    '1-Tap link must be a valid URL'
  ),
  // callReason: Yup.string().max(35, 'Call reason max'),
  // logo: Yup.string().url('Url not valid'),
  // .required('Logo is required'),
  // fullImage: Yup.string().url('Url not valid'),
  // .required('Full screen is required'),
  phone: Yup.array()
    .label()
    .of(
      Yup.string()
        .transform((value, originalValue) => {
          return normalizePhone(originalValue);
        })
        .matches(PHONE_REG_EXP, 'Phone number is not valid')
        .required('Phone number is required')
    ),
});
// validationSchema

function formatUrl(string) {
  try {
    if (!string) {
      return '';
    }
    if (!string.includes('http')) {
      return `https://${string}`;
    }

    return string;
  } catch (_) {
    return string;
  }
}
function isValidURL(string) {
  try {
    const isValid = validationSchema.validateSyncAt('linkActionUrl', {
      linkActionUrl: string,
    });
    return !!isValid;
  } catch (_) {
    return false;
  }
}

const csvFileKey = Object.freeze({
  phone: 'Phone Number',
  regions: 'Regions',
  callerDisplay: 'Caller ID Display',
  isCheckMark: 'Check Mark',
  prefixXi: 'Prefix Xi',
  prefixCircle: 'Prefix Circle',
  linkActionUrl: '1-Tap Link',
  linkActionType: '1-Tap Type',
});

const validationImportSchema = Yup.object().shape({
  callerDisplay: Yup.string().required('Caller ID Display is required'),
  // lastName: Yup.string().required("LastName is required"),
  phone: Yup.array()
    .label()
    .of(
      Yup.string()
        .transform((value, originalValue) => {
          return normalizePhone(originalValue);
        })
        .matches(PHONE_REG_EXP, 'Phone Number is not valid')
      // .required('phone number is required')
    ),
});

const regionOptions = [
  {
    value: 'Northeast',
    label: 'Northeast',
  },
  {
    value: 'Midwest',
    label: 'Midwest',
  },
  {
    value: 'South',
    label: 'South',
  },
  {
    value: 'West',
    label: 'West',
  },
];

function sortByCreatedAt(a, b) {
  return a.createdAt - b.createdAt;
}

export const RCDContact = ({
  userRole,
  showModal,
  modalAction,
  setShowModal,
  setModalAction,
  setToaster,
  tenant,
}) => {
  const [errorMessageApi, setErrorMessageApi] = useState();
  const [showMobile, setShowMobile] = useState('ios');
  const [showGalleryModal, setShowGalleryModal] = useState(false);
  const [disabledUpdateBtn, setDisabledUpdateBtn] = useState(true);

  const [showIosDeviceType, setShowIosDeviceType] = useState('old');
  const [singleImageUrl, setSingleImageUrl] = useState();
  const [searchText, setSearchText] = useState(() =>
    window.sessionStorage.getItem('contact_search_text')
  );
  const [contactData, setContactData] = useState([]);
  const [contactsCheckDuplicate, setContactsCheckDuplicate] = useState([]);

  const [editContact, setEditContact] = useState(null);

  const [filterRegions, setFilterRegions] = useState([]);
  const [isLoadingImport, setIsLoadingImport] = useState(false);

  const columns = [
    {
      name: 'Phone Number',
      selector: (row) => row['phone'],
      id: 'phone',
      cell: (row) => {
        return (
          <>
            {row['phone'] ? (
              <span onClick={() => handleEditContact(row)}>
                {row['phone']?.map((phoneItem, index) => (
                  <div>
                    {formatPhoneDisplay(phoneItem)}
                    {index !== row.phone.length - 1 && ','}
                  </div>
                ))}
                {/* {row['phone']
                  ?.map((item) => formatPhoneDisplay(item))
                  .join(', ')} */}
              </span>
            ) : (
              '-'
            )}
          </>
        );
      },
      sortable: true,
      key: 'phone',
      formatValue: (value) =>
        value.map((item) => formatPhoneDisplay(item)).join(','),
    },
    {
      name: 'Regions',
      cell: (row) => {
        return (
          <div>
            {row &&
            row.regions &&
            row.regions.length &&
            row.regions.length > 0 ? (
              <span>{row.regions.join(', ')}</span>
            ) : (
              '-'
            )}
          </div>
        );
      },
      key: 'regions',
      formatValue: (value) => value?.join(','),
      // sortable: true,
    },
    {
      name: 'Caller ID Display',
      selector: (row) => `${row.formatName}`,
      sortable: true,
      sortFunction: (rowA, rowB, cId) => {
        return rowA.firstName.localeCompare(rowB.firstName);
      },
      key: '_id',
      formatValue: (value, row) => `${row.formatName}`,
    },
    {
      name: 'Full Screen',
      cell: (row) => {
        // const rcdData = getContactRCD(row);
        // if (!rcdData.fullImage) {
        //   return '';
        // }
        return (
          <img
            className='table-user-img'
            onClick={() => {
              // setSingleImgModal(true);
              setSingleImageUrl(
                getImageUrl(row.galleryId) || gradientDefaultRinger
              );
            }}
            style={{
              cursor: 'pointer',
              objectFit: 'contain',
              objectPosition: 'center',
              background: 'rgba(0, 0, 0, 0.1)',
            }}
            src={getImageUrl(row.galleryId) || gradientDefaultRinger}
            alt='fullscreen'
            onError={(e) => {
              e.target.src = gradientDefaultRinger;
            }}
          />
        );
      },
      key: 'fullScreenUrl',
      // formatValue: (value) => (contactImages && contactImages[value]) ?? '',
      preventExport: true,
    },
    {
      name: 'Thumbnail',
      cell: (row) => {
        // const rcdData = getContactRCD(row);
        // if (!rcdData.logo) {
        //   return '';
        // }

        return (
          <img
            className='table-user-img'
            onClick={() => {
              // setSingleImgModal(true);
              setSingleImageUrl(
                getImageUrl(row.circleGalleryId) || defaultGallery
              );
            }}
            style={{
              cursor: 'pointer',
              objectFit: 'contain',
              objectPosition: 'center',
              background: 'rgba(0, 0, 0, 0.1)',
            }}
            onError={(e) => {
              e.target.src = defaultGallery;
            }}
            src={getImageUrl(row.circleGalleryId)}
            alt=''
          />
        );
      },
      key: 'circleGalleryId',
      // formatValue: (value) => (contactImages && contactImages[value]) ?? '',
      preventExport: true,
    },
    {
      name: '1-Tap Link',
      cell: (row) => {
        const isUrl = isValidURL(row.linkActionUrl);
        const optionLabel = optionOneTap.find(
          (item) => item.value === row.linkActionType
        );

        if (!isUrl) {
          return <span></span>;
        }
        if (isUrl) {
          return <span>{CHECK_MARK_SYMBOL}</span>;
        }

        return (
          <a
            className='link-new-tab'
            target='_blank'
            href={row.linkActionUrl}
            rel='noreferrer'>
            <OpenNewTabIcon />
            <span>{optionLabel?.label || optionOneTap[0].label}</span>
          </a>
        );
      },
      key: 'linkActionUrl',
      formatValue: (value, row) => value,
      // preventExport: true,
      center: true,
    },
    {
      name: '1-Tap Type',
      cell: (row) => {
        return <></>;
      },
      omit: true,
      key: 'linkActionType',
      formatValue: (value, row) => value,
      // preventExport: true,
      center: true,
    },
    {
      name: 'Edit Number',
      button: true,
      omit: userRole && userRole !== 'Administrator' && true,
      cell: (row) => {
        return (
          <div className='d-flex action-btn'>
            <button
              className='btn btn-sm'
              style={{ marginRight: '5px' }}
              onClick={() => handleEditContact(row)}>
              <EditIcon />
            </button>
          </div>
        );
      },
      preventExport: true,
    },
    {
      name: 'Delete Number',
      button: true,
      omit: userRole && userRole !== 'Administrator' && true,
      cell: (row) => {
        return (
          <div className='d-flex action-btn'>
            <button
              className='btn text-danger btn-sm'
              onClick={() => removeContact(row._id)}>
              <TrashIcon />
            </button>
          </div>
        );
      },
      preventExport: true,
    },
  ];
  const columnsImport = [
    {
      name: 'Phone Number',
      selector: (row) => row.phone,
      id: 'phone',
      cell: (row) => {
        return (
          <>
            {row.phone ? (
              <span>
                {row.phone?.map((phoneItem, index) => (
                  <div>
                    {formatPhoneDisplay(phoneItem)}
                    {index !== row.phone.length - 1 && ','}
                  </div>
                ))}
              </span>
            ) : (
              '-'
            )}
          </>
        );
      },
      sortable: true,
      key: 'phone',
    },
    {
      name: 'Regions',
      cell: (row) => {
        return (
          <div>
            {row?.regions?.length > 0 ? (
              <span>{row.regions.join(', ')}</span>
            ) : (
              '-'
            )}
          </div>
        );
      },
      key: 'regions',
      formatValue: (value) => value?.join(','),
      // sortable: true,
    },
    {
      name: 'Caller ID Display',
      selector: (row) => `${row.callerDisplay}`,
      sortable: true,
      sortFunction: (rowA, rowB, cId) => {
        return rowA?.callerDisplay?.localeCompare(rowB.callerDisplay);
      },
      key: 'id',
    },
    {
      name: 'Prefix Symbol',
      selector: (row) => `${row.prefixName}`,
      sortable: true,
      key: 'prefixName',
      center: true,
    },
    {
      name: 'Check Mark',
      selector: (row) => `${row.isCheckMark ? CHECK_MARK_SYMBOL : ''}`,
      sortable: true,
      key: 'isCheckMark',
      center: true,
    },
    {
      name: '1-Tap Link',
      selector: (row) => `${row.linkActionUrl || ''}`,
      sortable: true,
      key: 'linkActionUrl',
      center: true,
    },
    {
      name: '1-Tap type',
      selector: (row) => {
        const optionLabel = optionOneTap.find(
          (item) => item.value === row.linkActionType
        );

        return optionLabel?.label || optionOneTap[0].label;
      },
      sortable: true,
      key: 'linkActionType',
      center: true,
    },
    {
      name: '*',
      selector: (row) => renderErrorList(row.error, row),
      key: 'error',
      center: true,
    },
    {
      name: 'Remove',
      button: true,
      // omit: userRole && userRole !== 'Administrator' && true,
      maxWidth: '100px',
      cell: (row) => {
        return (
          <div className='d-flex action-btn'>
            <button
              className='btn text-danger btn-sm'
              onClick={() => removeImportContact(row.id)}>
              <TrashIcon />
            </button>
          </div>
        );
      },
      preventExport: true,
    },
  ];

  const [isUploadImage, setIsUploadImage] = useState('');

  const [contactsImportData, setContactsImportData] = useState([]);
  const [isLoadingSubmitImport, setIsLoadingSubmitImport] = useState(false);

  const [notifyAllMobileModal, setNotifyAllMobileModal] = useState(false);

  const [notificationError, setNotificationError] = useState({
    uuid: '',
    title: '',
    type: '',
  });
  const [notificationDetails, setNotificationDetails] = useState({
    title: '',
    silent: true,
  });

  const [galleryData, setGalleryData] = useState([]);
  const [galleryImages, setGalleryImages] = useState({});

  const [editImageData, setEditImageData] = useState({
    isOpen: false,
    imageUrl: '',
    type: '',
  });

  const {
    value: isOpenImport,
    setTrue: openImport,
    setFalse: closeImport,
  } = useBoolean();

  const { handleExport } = useExportData({
    filename: 'phone_number',
    columns,
  });

  const { galleryObject, prevProcessImage } = useGalleryBase64();

  const changeMobile = (modelName) => {
    setShowMobile(modelName);
  };

  function handleEditContact(value) {
    const newContactData = normalizeContactData(value);
    setEditContact(newContactData);
    setModalAction('edit');
    setShowModal(true);

    if (newContactData.fullScreenUrl) {
      prevProcessImage(newContactData.fullScreenUrl);
    }
    if (newContactData.logoUrl) {
      prevProcessImage(newContactData.logoUrl);
    }
  }

  const removeContact = async (rcdId) => {
    console.log('rcdId', rcdId);
    const wrapper = document.createElement('div');
    wrapper.innerHTML =
      '<p className="swal-text-data">Are you sure you want to delete this phone number?</p> ' +
      '<p className="swal-text-data">Deleting a phone number is a permanent action. Once removed it cannot be restored or modified</p>';
    swal({
      title: 'Delete Confirmation',
      content: wrapper,
      buttons: {
        confirm: {
          width: 30,
          text: 'Delete',
          value: 'delete',
          visible: true,
          className: 'swal-delete-button',
          closeModal: true,
        },
        cancel: {
          width: 15,
          text: 'Cancel',
          value: 'cancel',
          visible: true,
          className: 'swal-cancel-button',
          closeModal: true,
        },
      },
    }).then(async (willDelete) => {
      if (willDelete === 'delete') {
        const res = await deleteContact(rcdId);

        if (res.status === 204) {
          const tempContactsData = [...contactData];
          const updatedContactsData = tempContactsData.filter(
            (item) => item.id !== rcdId
          );
          setContactData(updatedContactsData?.map(normalizeContactData));
          setContactsCheckDuplicate(
            updatedContactsData?.map(normalizeContactData)
          );

          setToaster({
            show: true,
            message: 'Contact Successfully Deleted',
          });
        }
      }
    });
  };

  function getPrefixByName(name, currentPrefix) {
    if (!name) return DEFAULT_PREFIX;

    const findPrefixOption = optionPrefix.findLast((item) =>
      name?.startsWith(item.value)
    );
    return findPrefixOption
      ? findPrefixOption.value
      : currentPrefix || DEFAULT_PREFIX;
  }
  function getOnlyFirstName(name) {
    if (!name) return '';

    const findPrefixOption = optionPrefix.findLast((item) =>
      name?.startsWith(item.value)
    );

    return findPrefixOption
      ? name.replaceAll(findPrefixOption.value, '')
      : name;
  }

  function checkHasCheckMark(name) {
    if (!name) return false;

    return name?.includes(CHECK_MARK);
  }

  function normalizeContactData(contact = {}) {
    try {
      if (contact.name) {
        contact.firstName = contact.name;
      }

      const isCheckMark =
        checkHasCheckMark(contact.firstName) || contact.isCheckMark;

      if (!!contact.lastName?.trim()) {
        contact.firstName = `${contact.firstName} ${contact.lastName}`;
        contact.lastName = '';
      }

      const customContact = {
        ...contact,
        id: contact._id,
        regions: contact.regions ? contact.regions : [],
        firstName: getOnlyFirstName(
          isCheckMark
            ? contact.firstName.replaceAll(CHECK_MARK, '')
            : contact.firstName
        ),
        prefixName:
          getPrefixByName(contact.firstName, contact.prefixName) ||
          contact.prefixName,
        isCheckMark: isCheckMark,
        fullScreenUrl: getImageUrl(contact.galleryId),
        logoUrl: getImageUrl(contact.circleGalleryId),
        fullImage: getImageUrl(contact.galleryId),
        logo: getImageUrl(contact.circleGalleryId),

        phone: isArray(contact.phone)
          ? contact.phone.map((item) => normalizePhone(item))
          : contact.phone?.split(',')?.map((item) => normalizePhone(item)) || [
              normalizePhone(contact.phone),
            ],

        linkActionType: contact.linkActionType || optionOneTap[0].value,
        linkActionUrl: formatUrl(contact.linkActionUrl) || '',
      };

      console.log('customContact', customContact);

      customContact.formatName = `${customContact.prefixName}${
        customContact.isCheckMark ? CHECK_MARK : ''
      }${customContact.firstName}`;

      return customContact;
    } catch (error) {
      console.log('error', error);
      return null;
    }
  }

  async function handleUploadImage(files) {
    try {
      const data = await uploadImage(files);
      console.log('data', data);
    } catch (error) {
      setToaster({
        type: 'error',
        show: true,
        message: 'Upload failed',
      });
    } finally {
    }
  }

  function checkDuplicateContact(contact, listContact) {
    const messageError = [];
    const checkList = listContact?.length ? listContact : contactData;
    if (checkList?.length) {
      const filterCurrent = checkList.filter((item) => item.id !== contact.id);

      const isHasSameName = filterCurrent.some(
        (item) =>
          item.firstName?.trim().toLowerCase() ===
          contact.firstName?.trim().toLowerCase()
      );

      if (isHasSameName) {
        messageError.push('Duplicate Company Name');
      }

      const isHasSameCallerDisplay = filterCurrent.some(
        (item) =>
          item.firstName?.trim()?.toLowerCase() ===
          contact.callerDisplay?.trim()?.toLowerCase()
      );
      const listPhone = filterCurrent.map((item) => item.phone).flat();

      const isDuplicatePhone = contact.phone?.some((p) =>
        listPhone.some((item) => item === normalizePhone(p))
      );

      // Duplicate Phone and Caller ID Display

      if (isHasSameCallerDisplay && isDuplicatePhone) {
        messageError.push('Duplicate Phone and Caller ID Display');
      } else {
        if (isHasSameCallerDisplay) {
          messageError.push('Duplicate Caller ID Display');
        }

        if (isDuplicatePhone) {
          messageError.push('Duplicate Phone Number');
        }
      }
    }

    return messageError;
  }

  function handleCloseModalImport() {
    closeImport();
    setContactsImportData([]);
  }

  const submitFunction = async (value) => {
    try {
      if (modalAction === 'add') {
        value.phone = value.phone?.map((item) => normalizePhone(item));

        const errors = checkDuplicateContact(value);
        if (errors.length) {
          swal({
            className: 'error-swal',
            title: 'Create fail',
            text: errors[0],
            icon: 'error',
            dangerMode: true,
            button: false,
          });

          return;
        }

        value.firstName = `${value.prefixName?.trim()}${
          value.isCheckMark ? CHECK_MARK : ''
        }${value.firstName}`;

        value.lastName = ' ';

        if (value.fullImageFile) {
          const resFullImage = await uploadImage([value.fullImageFile], {
            // objectType: 'rcd_fullscreen',
            type: 'gallery',
          });
          value.galleryId = resFullImage.galleryId;
          getGalleryDetailById(setGalleryImages, value.galleryId);
        }

        if (value.logoFile) {
          const resFullImage = await uploadImage([value.logoFile], {
            // objectType: 'rcd_logo',
            type: 'circle',
          });

          value.circleGalleryId = resFullImage.galleryId;
          getGalleryDetailById(setGalleryImages, value.circleGalleryId);
        }

        if (value.linkActionUrl) {
          value.linkActionUrl = formatUrl(value.linkActionUrl);
        }

        const responseRCD = await createContacts(value);

        if (responseRCD.status === 201) {
          const data = {
            show: true,
            message: 'Contact Successfully Created',
          };
          setToaster(data);
          const newRCDData = responseRCD.data;

          setContactData((prevState) => [
            ...prevState,
            normalizeContactData(newRCDData),
          ]);
          setContactsCheckDuplicate((prevState) => [
            ...prevState,
            normalizeContactData(newRCDData),
          ]);

          handleClose();
        } else if (responseRCD.status === 409) {
          setErrorMessageApi(responseRCD.message);
        }
      } else {
        value.phone = value.phone?.map((item) => normalizePhone(item));

        const errors = checkDuplicateContact(
          value,
          [...contactData].filter((item) => item.id !== value.id)
        );

        if (errors.length) {
          swal({
            className: 'error-swal',
            title: 'Update failed',
            text: errors[0],
            icon: 'error',
            dangerMode: true,
            button: false,
          });
        } else {
          // delete value.id;

          value.firstName = `${value.prefixName?.trim()}${
            value.isCheckMark ? CHECK_MARK : ''
          }${value.firstName}`;

          value.lastName = ' ';

          if (value.fullImageFile) {
            if (value.galleryId && !value.fullImageFile.isAsNew) {
              await updateImage(value.galleryId, [value.fullImageFile], {
                type: IMAGE_TYPE.FULLSCREEN,
              });
            } else {
              const resFullImage = await uploadImage([value.fullImageFile], {
                type: IMAGE_TYPE.FULLSCREEN,
                avatar:
                  value.fullImageFile.name ||
                  `${value.firstName} - ${IMAGE_TYPE.FULLSCREEN}`,
              });
              value.galleryId = resFullImage.galleryId;
            }
            getGalleryDetailById(setGalleryImages, value.galleryId);
          }

          if (value.logoFile) {
            if (value.circleGalleryId && !value.logoFile.isAsNew) {
              await updateImage(value.circleGalleryId, [value.logoFile], {
                type: IMAGE_TYPE.LOGO,
              });
            } else {
              const resFullImage = await uploadImage([value.logoFile], {
                // objectType: 'rcd_logo',
                type: IMAGE_TYPE.LOGO,
                avatar:
                  value.logoFile.name ||
                  `${value.firstName} - ${IMAGE_TYPE.LOGO}`,
              });
              value.circleGalleryId = resFullImage.galleryId;
            }

            getGalleryDetailById(setGalleryImages, value.circleGalleryId);
          }

          if (value.linkActionUrl) {
            value.linkActionUrl = formatUrl(value.linkActionUrl);
          }

          const response = await updateContacts(value.id, value);
          if (response.status === 200) {
            const tempContactsData = [...contactData];
            const indexData = tempContactsData.findIndex(
              (item) => item._id === response.data._id
            );
            tempContactsData[indexData] = response.data;
            setContactData(tempContactsData?.map(normalizeContactData));
            setContactsCheckDuplicate(
              tempContactsData?.map(normalizeContactData)
            );

            handleClose();
          } else if (response.status === 409) {
            setErrorMessageApi(response.message);
          }
        }
      }
    } catch (error) {
      console.log('error', error);
    } finally {
    }
  };

  async function fetchData(value) {
    try {
      const objectBody = {
        q: value || '*',
      };
      const res = await searchContacts(objectBody);
      if (res.status === 200) {
        setContactData(
          res.data.objects
            ?.map(normalizeContactData)
            .filter((item) => item?.id) || []
        );
        setContactsCheckDuplicate(
          res.data.objects
            ?.map(normalizeContactData)
            .filter((item) => item?.id) || []
        );
      }

      // const data = { q: '*' };

      // const res = await searchContacts(data);
      // // syncContactDetails(res);
      // const resultObject =
      //   res && res.data && res.data.objects ? res.data.objects : null;

      // const foundArray = [];
      // if (res.status === 200) {
      //   if (res.data.total > 0 && value !== '') {
      //     resultObject.map((key) => {
      //       Object.values(key).find((i) => {
      //         if (Array.isArray(i)) {
      //           if (i.find((key) => key.includes(value))) {
      //             foundArray.push(key);
      //           }
      //         } else if (typeof i == 'string') {
      //           if (i.includes(value)) {
      //             foundArray.push(key);
      //           }
      //         }
      //       });
      //     });

      //     setContactData(foundArray?.map(normalizeContactData));
      //     // setContactsData(res.data.objects);
      //   } else if (value == '') {
      //     setContactData(resultObject?.map(normalizeContactData));
      //   }
      // }
    } catch (error) {
      //
    }
  }

  function getImageUrl(id) {
    return galleryImages?.[id] || '';
  }

  const search = useDebounce(async (value) => {
    await fetchData(value);
  }, 300);

  const handleClose = () => {
    setModalAction(null);
    setShowModal(false);
    setEditImageData((prevState) => ({
      ...prevState,
      isOpen: false,
      type: 'fullscreen',
      imageUrl: '',
      imageId: '',
      isOneTap: false
    }));
  };

  const handleFilterRegions = (newValue, actionMeta) => {
    // switch (actionMeta.action) {
    //   case 'remove-value':
    //   case 'pop-value':
    //     if (actionMeta.removedValue.isFixed) {
    //       return;
    //     }
    //     break;
    //   case 'clear':
    //     newValue = colourOptions.filter((v) => v.isFixed);
    //     break;
    // }

    setFilterRegions(newValue);
  };

  // async function handleUploadImage(files) {
  //   if (files?.length) {
  //     const file = files[0];
  //     if (!file.preview) {
  //       return;
  //     }
  //     const formData = new FormData();
  //     formData.append('fieldModifiers', JSON.stringify({ avatar: file.name }));

  //     let demo = await fetch(file.preview).then((r) => r.blob());

  //     formData.append('file', demo);

  //     const res = await createLogo(formData);
  //     console.log('res', res);
  //   }
  // }

  function handleImport() {
    openImport();
  }

  function getNotiMessageByTenant() {
    let displayName = tenant?.name;
    switch (tenant.namespace) {
      case 'ringc':
        displayName = 'Ringer';
        break;
      default:
        break;
    }
    // getTenantName
    return `New ${displayName} Display`;
  }

  const notifyAllMobile = async () => {
    if (!notificationDetails.silent && !notificationDetails.title) {
      setNotificationError({
        ...notificationError,
        title: 'Title is required',
      });
      return;
    }
    if (notificationDetails.silent === '') {
      setNotificationError({
        ...notificationError,
        type: 'Type is required',
      });
      return;
    }

    let data = [];

    // let data = {
    //   ...notificationDetails,
    //   message: 'New Ringer Display',
    //   from: '+18582480098',
    // };
    // if (data['title'] === '') {
    //   data['title'] = 'ringc';
    // }
    if (!notificationDetails.silent) {
      data.push(
        {
          ...notificationDetails,
          silent: true,
          title: 'ringc',
          message: getNotiMessageByTenant(),
          from: '+18582480098',
        },
        {
          ...notificationDetails,
          silent: false,
          message: getNotiMessageByTenant(),
          from: '+18582480098',
        }
      );
    } else {
      data.push({
        ...notificationDetails,
        title: 'ringc',
        message: getNotiMessageByTenant(),
        from: '+18582480098',
      });
    }

    try {
      if (data.length) {
        await Promise.all(data.map((d) => allMobileNotification(d)));

        const msgData = {
          show: true,
          message: 'Notification Send Successfully',
        };

        setToaster(msgData);
        setNotifyAllMobileModal(false);
        setNotificationDetails({ title: '', silent: true });
      }
    } catch (error) {}

    // data &&
    //   data.forEach(async (d) => {
    //     const response = await allMobileNotification(d);
    //     if (response.status === 204) {
    //       const msgData = {
    //         show: true,
    //         message: 'Notification Send Successfully',
    //       };
    //       setToaster(msgData);
    //       setNotifyAllMobileModal(false);
    //       setNotificationDetails({ title: '', silent: true });
    //     }
    //   });
    // const response = await allMobileNotification(data);
  };

  const validateData = (data = []) => {
    return data.map((val) => {
      const { phone, callerDisplay } = val;

      let messageError = '';
      try {
        validationImportSchema.validateSync(
          {
            phone,
            callerDisplay,
          },
          { abortEarly: false }
        );

        const errors = checkDuplicateContact(val);

        if (errors.length) {
          throw {
            errors,
          };
        }

        const errorsInList = checkDuplicateContact(
          val,
          [...data].filter((item) => item.id === val.id)
        );

        if (errorsInList.length) {
          throw new Error('Duplicate contacts in file');
        }

        // const findSameName = contactsData.find(
        //   (item) => item.firstName?.trim() === callerDisplay
        // );

        // if (findSameName) {
        //   const findSamePhone = findSameName.phone?.find((item) =>
        //     phone.includes(item)
        //   );

        //   if (findSamePhone) {
        //     throw new Error('Duplicate Phone and Caller ID Display');
        //   }
        // }

        // firstName
      } catch (error) {
        messageError = error?.errors || [
          error?.message || 'Something  went wrong',
        ];
      }

      return {
        ...val,
        valid: !messageError?.length,
        error: messageError,
      };
    });
  };

  const mapKeyData = (data = []) =>
    data.map((i) => ({
      ...i,
      phone: i[csvFileKey.phone],
      regions: i[csvFileKey.regions],
      callerDisplay: i[csvFileKey.callerDisplay],
      isCheckMark: i[csvFileKey.isCheckMark],
      prefixName: i[csvFileKey.prefixName],
      prefixCircle: i[csvFileKey.prefixCircle],
      prefixXi: i[csvFileKey.prefixXi],
      linkActionUrl: i[csvFileKey.linkActionUrl],
      linkActionType: i[csvFileKey.linkActionType],
    }));

  const normalizeImportData = (data = []) =>
    data?.map((e, index) => {
      delete e[csvFileKey.callerDisplay];
      delete e[csvFileKey.phone];
      delete e[csvFileKey.regions];
      delete e[csvFileKey.isCheckMark];
      delete e[csvFileKey.prefixXi];
      delete e[csvFileKey.prefixCircle];
      // delete e[csvFileKey.prefixName];

      let prefixName = DEFAULT_PREFIX;

      if (textToBooleanImportField(e.prefixCircle)) {
        prefixName = PREFIX_CIRCLE;
      }

      if (textToBooleanImportField(e.prefixXi)) {
        prefixName = PREFIX_XI;
      }

      return {
        ...e,
        callerDisplay: e.callerDisplay?.trim() || '',
        phone: e.phone?.split(',')?.map((item) => normalizePhone(item)) || [
          normalizePhone(e.phone),
        ],
        regions: e.regions?.split(',') || [e.regions],
        id: index + 1,
        // isCheckMark: !!e.isCheckMark?.includes(CHECK_MARK_SYMBOL),
        isCheckMark: textToBooleanImportField(e.isCheckMark),

        prefixName: prefixName,
      };
    });

  const isValidHeaderKeys = (currentKeys = []) => {
    const expectedKeys = Object.values(csvFileKey);

    // return currentKeys.every((i) => expectedKeys.includes(i));
    return expectedKeys.every((i) => currentKeys.includes(i));
  };

  const renderErrorList = (list, row) => {
    return (
      <div>
        {!row?.valid ? (
          <ul
            className='mb-0 p-0'
            style={{
              textAlign: 'left',
              listStyleType: "'-  '",
              maxWidth: '300px',
            }}>
            {list?.map(
              (item, index) =>
                !_isEmpty(item) && (
                  <li key={index}>
                    <div className='text text-danger'>{`${item}`}</div>
                  </li>
                )
            )}
          </ul>
        ) : (
          <i class='fa fa-duotone fa-check text-success'></i>
        )}
      </div>
    );
  };
  const removeImportContact = async (contactId) => {
    const wrapper = document.createElement('div');
    wrapper.innerHTML =
      '<p className="swal-text-data">Are you sure you want to delete this phone number?</p> ';
    swal({
      title: 'Delete Confirmation',
      content: wrapper,
      buttons: {
        confirm: {
          width: 30,
          text: 'Delete',
          value: 'delete',
          visible: true,
          className: 'swal-delete-button',
          closeModal: true,
        },
        cancel: {
          width: 15,
          text: 'Cancel',
          value: 'cancel',
          visible: true,
          className: 'swal-cancel-button',
          closeModal: true,
        },
      },
    }).then((willDelete) => {
      if (willDelete === 'delete') {
        setContactsImportData((prevState) =>
          prevState.filter((item) => item.id !== contactId)
        );
      }
    });
  };

  const handleSubmitImportData = async () => {
    try {
      setIsLoadingSubmitImport(true);
      let errorResItem = [];
      const response = await Promise.all([
        ...contactsImportData.map((item) =>
          createContacts({
            phone: item.phone?.map((item) => normalizePhone(item)),
            // firstName: item.callerDisplay,
            firstName: `${item.prefixName?.trim()}${
              item.isCheckMark ? CHECK_MARK : ''
            }${item.callerDisplay}`,
            regions: item.regions,
            lastName: ' ',
            linkActionType: item.linkActionType,
            linkActionUrl: formatUrl(item.linkActionUrl),
          }).catch(() => {
            errorResItem.push({ ...item });
          })
        ),
      ]);

      if (errorResItem.length) {
        setToaster({
          show: true,
          message: (
            <div>
              <h5>Can't create contact</h5>
              <ul
                className='mb-0 p-0'
                style={{
                  textAlign: 'left',
                  listStyleType: "'-  '",
                  maxWidth: '300px',
                }}>
                {errorResItem
                  .map((item) => item.phone)
                  .flat()
                  ?.map(
                    (phone, index) =>
                      !_isEmpty(phone) && (
                        <li key={index}>
                          <div className='text text-danger'>
                            {formatPhoneDisplay(phone)}
                          </div>
                        </li>
                      )
                  )}
              </ul>
              {/* {errorResItem.map((item) => item.phone).flat()} fail */}
            </div>
          ),
        });
      }

      const isSomeSuccess = response?.some((item) => item.status === 201);
      if (isSomeSuccess) {
        setToaster({
          show: true,
          message: 'Contact Successfully Created',
        });
        setContactData((prevState) => [
          ...prevState,
          normalizeContactData(response.data),
        ]);
        setContactsCheckDuplicate((prevState) => [
          ...prevState,
          normalizeContactData(response.data),
        ]);

        fetchData();
        handleCloseModalImport();
      }
    } catch (error) {
      setToaster({
        show: true,
        message: 'Something went wrong',
      });
    } finally {
      setIsLoadingSubmitImport(false);
    }

    // setButtonEvent(false);
  };

  const changeFileHandler = (event) => {
    setIsLoadingImport(true);
    if (!event.target.files[0]) {
      return;
    }
    Papa.parse(event.target.files[0], {
      header: true,
      aborted: false,
      delimiter: ',',
      linebreak: '\r\n',
      truncated: false,
      skipEmptyLines: true,
      complete: function (results) {
        if (_isEmpty(results.data)) {
          setToaster({
            show: true,
            message: 'Empty data!',
          });
          return;
        }

        results.data = results.data.map((item) => {
          Object.keys(item).forEach((key) => {
            const trimKey = key.trim();
            if (trimKey !== key) {
              item[trimKey] = item[key];
              delete item[key];
            }
          });
          return item;
        });

        const currentKeys = Object.keys(results.data.find(Boolean));

        if (!isValidHeaderKeys(currentKeys)) {
          setToaster({
            show: true,
            message: 'Header format invalid',
          });
          return;
        }

        const formattedData = _flow(
          mapKeyData,
          normalizeImportData,
          validateData
        )(results.data);

        console.log('formattedData', formattedData);

        setContactsImportData(formattedData);
        setIsLoadingImport(false);
        // setCodeErrors([]);
      },
    });
    return true;
  };

  const updateArea = (name, setFieldValue) => {
    if (name === 'selectAll') {
      setFieldValue('regions', ['Northeast', 'Midwest', 'South', 'West']);
    } else if (name === 'removeAll') {
      setFieldValue('regions', []);
    }
  };

  async function syncGalleryData() {
    try {
      fetchGalleryDetails(setGalleryData, setGalleryImages);
    } catch (error) {}
  }

  function syncGalleryDataToContact() {
    const cloneContact = [...contactData];
  }

  function handleCloseEditImage() {
    setEditImageData((prevState) => ({
      ...prevState,
      isOpen: false,
      type: 'fullscreen',
      imageId: '',
      isOneTap: false,
    }));
  }

  const filterTable = useMemo(
    () =>
      contactData
        .filter(
          (item) =>
            !filterRegions.length ||
            filterRegions.every((fItem) => item.regions?.includes(fItem.value))
        )
        .sort(sortByCreatedAt),
    [filterRegions, contactData]
  );

  useEffect(() => {
    if (galleryData.length) {
      syncGalleryDataToContact();
    }
  }, [galleryData]);

  useEffect(() => {
    const isValidData = contactsImportData?.every(({ valid }) => valid);

    setDisabledUpdateBtn(!contactsImportData?.length || !isValidData);
  }, [contactsImportData]);

  useEffect(() => {
    window.sessionStorage.setItem('contact_search_text', searchText || '');
  }, [searchText]);

  useEffect(() => {
    fetchData(searchText || '');
    syncGalleryData();
  }, []);

  const initialPreviewScreen = {};

  return (
    <div id='pageWrapper'>
      <div className='page-wrapper'>
      <div className='main-page'>
        <section className='common-sec contact-sec card-body-no-padding'>
          <div className='container-fluid'>
            <div className='row'>
              <div className='col-12'>
                <Card>
                  <Card.Header>
                    <div className='card-header-inner'>
                      <div className='card-header-inner-left'>
                        <h2>Phone Numbers</h2>
                      </div>
                      <div className='card-header-inner-right'>
                        <div className='contact-title'>
                          {/* <Button
                            className='btn-sm notify-mobile-btn'
                            variant='primary'
                            onClick={handleImport}>
                            <i className='fas fa-file-import'></i> Import
                          </Button> */}

                          <Button
                            className='btn-sm notify-mobile-btn'
                            variant='primary'
                            onClick={handleImport}>
                            <i className='fas fa-file-import'></i> Import
                          </Button>
                          <Button
                            className='btn-sm notify-mobile-btn'
                            variant='primary'
                            onClick={() => handleExport(filterTable)}>
                            <i className='fas fa-file-export'></i> Export
                          </Button>

                          <Button
                            className='btn-sm notify-mobile-btn'
                            variant='primary'
                            onClick={() => setNotifyAllMobileModal(true)}>
                            Notify All
                          </Button>

                          <Button
                            className='btn-sm'
                            variant='primary'
                            onClick={() => {
                              setModalAction('add');
                              setShowModal(true);
                            }}>
                            <i className='fas fa-plus'></i> Add
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <div className='contact-wrap'>
                      <div className='container-fluid'>
                        <div className='row'>
                          <div className='col-12 col-md-6 col-sm-12'>
                            <div className='contact-filter mb-3'>
                              <div className='input-group'>
                                <input
                                  className='form-control'
                                  type='text'
                                  autocomplete='none'
                                  name='search'
                                  placeholder='Search'
                                  value={searchText}
                                  onChange={(e) => {
                                    setSearchText(e.target.value);
                                    search(e.target.value);
                                  }}
                                />
                                {searchText && (
                                  <svg
                                    onClick={() => {
                                      setSearchText('');
                                      search('');
                                    }}
                                    className='close-icon'
                                    xmlns='http://www.w3.org/2000/svg'
                                    width='30'
                                    height='30'
                                    viewBox='0 0 21 21'>
                                    <path
                                      fill='none'
                                      stroke='currentColor'
                                      stroke-linecap='round'
                                      stroke-linejoin='round'
                                      d='m7.5 7.5l6 6m0-6l-6 6'
                                    />
                                  </svg>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className='col-12 col-md-6 col-sm-12'>
                            <div className='contact-filter mb-3'>
                              <Select
                                isMulti
                                name='filterRegions'
                                value={filterRegions}
                                defaultValue={
                                  [
                                    // regionOptions[0],
                                    // regionOptions[1],
                                    // regionOptions[2],
                                    // regionOptions[3],
                                  ]
                                }
                                className='basic-multi-select'
                                classNamePrefix='select'
                                options={regionOptions}
                                placeholder='Filter regions'
                                onChange={handleFilterRegions}
                                // styles={styles}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className='contact-data contact-data-table common-data-table'>
                          <TableComponent
                            // title='Contacts'
                            columns={columns}
                            data={filterTable}
                          />
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </div>
              <Modal
                size='lg'
                show={showModal}
                onHide={handleClose}
                className='contact-update-modal'
                backdrop='static'
                key='modal-form'
                centered>
                <Modal.Header closeButton>
                  <Modal.Title>
                    {modalAction === 'add' ? (
                      <h2>Add Contact</h2>
                    ) : (
                      <h2>Edit Contact</h2>
                    )}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Formik
                    enableReinitialize={true}
                    initialValues={
                      modalAction === 'add'
                        ? initialValues
                        : editContact || initialValues
                    }
                    validationSchema={validationSchema}
                    onSubmit={async (value, { resetForm }) => {
                      await submitFunction(value);
                    }}>
                    {({
                      values,
                      errors,
                      isValid,
                      setFieldValue,
                      setFieldTouched,
                      isSubmitting,
                      submitCount,
                    }) => (
                      <div className='row'>
                        <div className='col-12 col-lg-12 col-md-12 col-sm-12 text-danger'>
                          {errorMessageApi}
                        </div>
                        <div className='col-12 col-lg-6 col-md-12 col-sm-12'>
                          <div className='edit-detail-form pt-3'>
                            <Form>
                              {modalAction === 'add' ? null : (
                                <>
                                  <Field type='hidden' name='id' />
                                  <Field type='hidden' name='galleryId' />
                                  <Field type='hidden' name='circleGalleryId' />
                                  <Field type='hidden' name='logo' />
                                  <Field type='hidden' name='fullImage' />
                                  <Field type='hidden' name='fullScreenUrl' />
                                  <Field type='hidden' name='logoUrl' />
                                </>
                              )}
                              <div className='row'>
                                <div className='col-12 col-md-6 col-lg-6 mb-3'>
                                  <div
                                    className='form-group file-upload flex-nowrap'
                                    onClick={(e) => {
                                      values.fullScreenUrl
                                        ? setEditImageData({
                                            type: 'fullscreen',
                                            isOpen: true,
                                            imageUrl: values.fullScreenUrl,
                                            imageId: values.galleryId,
                                            isOneTap: isValidURL(values.linkActionUrl)
                                          })
                                        : setIsUploadImage('fullImage');
                                    }}>
                                    <img
                                      src={
                                        values.fullScreenUrl ||
                                        gradientDefaultRinger
                                      }
                                      alt=''
                                    />
                                    <span>
                                      {!values.fullScreenUrl
                                        ? 'Select Image'
                                        : 'Edit image'}
                                    </span>
                                  </div>
                                  {modalAction === 'edit' && (
                                    <div>
                                      <Button
                                        onClick={() => {
                                          setIsUploadImage('fullImage');
                                        }}>
                                        Select Image
                                      </Button>
                                    </div>
                                  )}
                                </div>

                                <div className='col-12 col-md-6 col-lg-6 mb-3'>
                                  <div
                                    className='form-group file-upload flex-nowrap'
                                    onClick={(e) => {
                                      values.logoUrl
                                        ? setEditImageData({
                                            type: 'logo',
                                            isOpen: true,
                                            imageUrl: values.logoUrl,
                                            imageId: values.circleGalleryId,
                                          })
                                        : setIsUploadImage('logo');
                                    }}>
                                    <img
                                      // src={
                                      //   modalAction === 'edit' &&
                                      //   previewScreen.logo ===
                                      //     gradientDefaultRinger
                                      //     ? contactImages[editInitialValues.id]
                                      //     : previewScreen.logo
                                      // }

                                      src={values.logoUrl || defaultGallery}
                                      onError={(e) => {
                                        e.target.src = defaultGallery;
                                      }}
                                      alt='logoUrl'
                                    />
                                    <span>
                                      {!values.logoUrl
                                        ? 'Select thumbnail'
                                        : 'Edit thumbnail'}
                                    </span>
                                  </div>
                                  {modalAction === 'edit' && (
                                    <div>
                                      <Button
                                        onClick={(e) =>
                                          setIsUploadImage('logo')
                                        }>
                                        Select thumbnail
                                      </Button>
                                    </div>
                                  )}
                                </div>

                                <div className='col-12 col-md-12 col-lg-12 mb-3'>
                                  <FormGroup tag='fieldset'>
                                    <legend className='fs-6'>
                                      Select prefix
                                    </legend>
                                    {optionPrefix.map((item) => (
                                      <div className='form-check form-check-inline cursor-pointer mr-1'>
                                        <Field
                                          className='form-check-input'
                                          type='radio'
                                          name='prefixName'
                                          value={item.value}
                                          onChange={(e) => {
                                            // setPreviewScreen((prevState) => ({
                                            //   ...prevState,
                                            //   prefixName: e.target.value,
                                            // }));
                                            setFieldValue(
                                              'prefixName',
                                              e.target.value
                                            );
                                          }}
                                          id={`prefixName_${item.value}`}
                                        />
                                        <label
                                          style={{
                                            minWidth: '5px',
                                          }}
                                          className='form-check-label w-100 cursor-pointer'
                                          htmlFor={`prefixName_${item.value}`}>
                                          {item.label}
                                        </label>
                                      </div>
                                    ))}
                                    <div className='form-group mt-2'>
                                      <Field
                                        type='checkbox'
                                        name='isCheckMark'
                                        onChange={(e) => {
                                          // setPreviewScreen((prevState) => ({
                                          //   ...prevState,
                                          //   isCheckMark: e.target.checked,
                                          // }));
                                          setFieldValue(
                                            'isCheckMark',
                                            e.target.checked
                                          );
                                        }}
                                      />
                                      <label htmlFor='isCheckMark'>
                                        Add checkmark {CHECK_MARK}
                                      </label>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className='col-12 col-md-12 col-lg-12 mb-3'>
                                  <div className='form-group'>
                                    <Field
                                      className='form-control'
                                      type='text'
                                      name='firstName'
                                      placeholder='Company name'
                                      onChange={(e) => {
                                        setFieldValue(
                                          'firstName',
                                          e.target.value
                                        );
                                      }}
                                    />
                                    <ErrorMessage name='firstName'>
                                      {(msg) => (
                                        <span
                                          className='fm_error'
                                          style={{ color: 'red' }}>
                                          {msg}
                                        </span>
                                      )}
                                    </ErrorMessage>
                                  </div>
                                </div>
                                {/* <div className='col-12 col-md-6 col-lg-12 mb-3'>
                                  <div className='form-group'>
                                    <Field
                                      className='form-control'
                                      type='text'
                                      name='lastName'
                                      placeholder='Last Name'
                                      onChange={(e) => {
                                        setPreviewScreen((prevState) => ({
                                          ...prevState,
                                          lastName: e.target.value,
                                        }));
                                        setFieldValue(
                                          'lastName',
                                          e.target.value
                                        );
                                      }}
                                    />
                                    <ErrorMessage name='lastName'>
                                      {(msg) => (
                                        <span
                                          className='fm_error'
                                          style={{ color: 'red' }}>
                                          {msg}
                                        </span>
                                      )}
                                    </ErrorMessage>
                                  </div>
                                </div> */}
                                <div className='col-12 col-md-12 col-lg-12 mb-3 cs_phone_with_plus'>
                                  <div className='form-group'>
                                    <FieldArray name='mobile-array hidden'>
                                      {() => (
                                        <div>
                                          {values.phone.map(
                                            (canList, index) => (
                                              <div key={index} className='row'>
                                                <Field
                                                  className='form-control'
                                                  type='text'
                                                  name={`phone[${index}]`}>
                                                  {({
                                                    field, // { name, value, onChange, onBlur }
                                                    form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                                                    meta,
                                                  }) => (
                                                    <ReactInputMask
                                                      className='form-control'
                                                      mask='(999) 999-9999'
                                                      value={field.value}
                                                      name={`phone[${index}]`}
                                                      placeholder='Phone number'
                                                      onChange={(e) => {
                                                        if (index === 0) {
                                                          // setPreviewScreen(
                                                          //   (prevState) => ({
                                                          //     ...prevState,
                                                          //     phone:
                                                          //       e.target.value,
                                                          //   })
                                                          // );
                                                        }
                                                        setFieldValue(
                                                          `phone[${index}]`,
                                                          e.target.value
                                                        );
                                                      }}
                                                    />
                                                  )}
                                                </Field>

                                                <div className='plus_btn'>
                                                  {
                                                    // values.phone.length ===
                                                    // index + 1
                                                    index === 0 ? (
                                                      <button
                                                        className='add-new-modal btn-primary'
                                                        type='button'
                                                        onClick={(e) =>
                                                          setFieldValue(
                                                            'phone',
                                                            [
                                                              ...values.phone,
                                                              '',
                                                            ]
                                                          )
                                                        }>
                                                        <i className='fa fa-plus'></i>
                                                      </button>
                                                    ) : (
                                                      <button
                                                        className='add-new-modal btn-primary'
                                                        type='button'
                                                        onClick={() => {
                                                          values.phone.splice(
                                                            index,
                                                            1
                                                          );
                                                          setFieldValue(
                                                            'phone',
                                                            [...values.phone]
                                                          );
                                                        }}>
                                                        <i className='fa fa-minus'></i>
                                                      </button>
                                                    )
                                                  }
                                                </div>
                                                <ErrorMessage
                                                  name={`phone[${index}]`}>
                                                  {(msg) => (
                                                    <span
                                                      className='fm_error'
                                                      style={{ color: 'red' }}>
                                                      {msg}
                                                    </span>
                                                  )}
                                                </ErrorMessage>
                                              </div>
                                            )
                                          )}
                                        </div>
                                      )}
                                    </FieldArray>
                                  </div>
                                  <span>Input 10 digits with no spaces</span>
                                </div>
                                <div className='col-12 col-md-12 col-lg-12 mb-3'>
                                  <FormGroup tag='fieldset'>
                                    <legend className='fs-6'>1-Tap link</legend>

                                    <div className='form-group'>
                                      <div className='form-link-action'>
                                        <Field
                                          className='form-control'
                                          type='text'
                                          name='linkActionUrl'
                                          placeholder='1-Tap URL'
                                          onChange={(e) => {
                                            setFieldValue(
                                              'linkActionUrl',
                                              e.target.value
                                            );
                                          }}
                                        />
                                        <div>
                                          <a
                                            role='button'
                                            aria-disabled='true'
                                            className={`btn btn-primary btn-open-new ${
                                              isValidURL(values.linkActionUrl)
                                                ? ''
                                                : 'disabled'
                                            }`}
                                            target='_blank'
                                            href={
                                              isValidURL(values.linkActionUrl)
                                                ? formatUrl(
                                                    values.linkActionUrl
                                                  )
                                                : '#'
                                            }
                                            rel='noreferrer'>
                                            <OpenNewTabIcon className='icon-open-tab' />
                                          </a>
                                        </div>
                                      </div>
                                      <div>
                                        <ErrorMessage name='linkActionUrl'>
                                          {(msg) => (
                                            <span
                                              className='fm_error'
                                              style={{ color: 'red' }}>
                                              {msg}
                                            </span>
                                          )}
                                        </ErrorMessage>
                                      </div>

                                      <div className='mt-2'>
                                        {optionOneTap.map((item) => (
                                          <div className='form-check form-check-inline cursor-pointer mr-1'>
                                            <Field
                                              disabled={
                                                !values?.linkActionUrl?.length
                                              }
                                              className='form-check-input'
                                              type='radio'
                                              name='linkActionType'
                                              value={item.value}
                                              onChange={(e) => {
                                                // setPreviewScreen((prevState) => ({
                                                //   ...prevState,
                                                //   linkActionType: e.target.value,
                                                // }));
                                                setFieldValue(
                                                  'linkActionType',
                                                  e.target.value
                                                );
                                              }}
                                              id={`linkActionType_${item.value}`}
                                            />
                                            <label
                                              style={{
                                                minWidth: '5px',
                                              }}
                                              className='form-check-label w-100 cursor-pointer'
                                              htmlFor={`linkActionType_${item.value}`}>
                                              {item.label}
                                            </label>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>
                                {/* <div className='col-12 col-md-12 col-lg-12 mb-3'>
                                  <div className='form-group'>
                                    <Field
                                      className='form-control'
                                      type='text'
                                      maxLength={35}
                                      name='callReason'
                                      placeholder='Call reason'
                                      onChange={(e) => {
                                        setFieldValue(
                                          'callReason',
                                          e.target.value
                                        );
                                      }}
                                    />
                                    <ErrorMessage name='callReason'>
                                      {(msg) => (
                                        <span
                                          className='fm_error'
                                          style={{ color: 'red' }}>
                                          {msg}
                                        </span>
                                      )}
                                    </ErrorMessage>
                                  </div>
                                </div>
                                <div className='col-12 col-md-12 col-lg-12 mb-3'>
                                  <div>
                                    <ErrorMessage name='fullImage'>
                                      {(msg) => (
                                        <span
                                          className='fm_error '
                                          style={{ color: 'red' }}>
                                          {msg}
                                        </span>
                                      )}
                                    </ErrorMessage>
                                  </div>
                                  <div>
                                    <ErrorMessage name='logoUrl'>
                                      {(msg) => (
                                        <span
                                          className='fm_error '
                                          style={{ color: 'red' }}>
                                          {msg}
                                        </span>
                                      )}
                                    </ErrorMessage>
                                  </div>
                                </div> */}

                                <div className='col-12 col-md-12 col-lg-12'>
                                  <div className='form-group region-selector'>
                                    <h5 className='select-region'>
                                      Select Region
                                    </h5>
                                    <div className='clear-filter'>
                                      <div
                                        onClick={() =>
                                          updateArea('removeAll', setFieldValue)
                                        }>
                                        Clear All
                                      </div>
                                      <div
                                        onClick={() =>
                                          updateArea('selectAll', setFieldValue)
                                        }>
                                        Select All
                                      </div>
                                    </div>
                                  </div>
                                  <div className='form-group'>
                                    <div className='filter-option-wrap'>
                                      <div className='form-group'>
                                        <Field
                                          type='checkbox'
                                          name='regions'
                                          value='Northeast'
                                        />
                                        <label htmlFor='filter_1'>
                                          Region 1: Northeast
                                        </label>
                                      </div>
                                      <div className='form-group'>
                                        <Field
                                          type='checkbox'
                                          name='regions'
                                          value='Midwest'
                                        />
                                        <label htmlFor='filter_2'>
                                          Region 2: Midwest
                                        </label>
                                      </div>
                                      <div className='form-group'>
                                        <Field
                                          type='checkbox'
                                          name='regions'
                                          value='South'
                                        />
                                        <label htmlFor='filter_3'>
                                          Region 3: South
                                        </label>
                                      </div>
                                      <div className='form-group'>
                                        <Field
                                          type='checkbox'
                                          name='regions'
                                          value='West'
                                        />
                                        <label htmlFor='filter_4'>
                                          Region 4: West
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className='col-12 col-md-12 col-lg-12 justify-content-end d-flex'>
                                  <Button
                                    disabled={
                                      isSubmitting ||
                                      (!isValid && submitCount > 0)
                                    }
                                    type='submit'
                                    variant='primary'
                                    // isLoadingSubmitImport
                                    className='d-flex align-items-center px-5 py-2'>
                                    {isSubmitting && (
                                      <Spinner
                                        as='span'
                                        animation='border'
                                        size='sm'
                                        role='status'
                                        aria-hidden='true'
                                      />
                                    )}
                                    <span className='ps-1'>
                                      {modalAction === 'add' ? 'Add' : 'Save'}
                                    </span>
                                  </Button>
                                </div>
                              </div>
                            </Form>
                          </div>
                        </div>
                        <div className='col-12 col-lg-6 col-md-12 col-sm-12'>
                          <div className='contact-mobile-wrapper'>
                            <div className='mobile-tab-wrapper'>
                              <ul>
                                <li
                                  className={
                                    showMobile === 'ios' ? 'active' : ''
                                  }
                                  onClick={() => changeMobile('ios')}>
                                  <AppleIcon />
                                </li>
                                <li
                                  className={
                                    showMobile === 'android' ? 'active' : ''
                                  }
                                  onClick={() => changeMobile('android')}>
                                  <AndroidIcon />
                                </li>
                              </ul>
                              {showMobile === 'ios' && (
                                <ul className='ios-mobile-type'>
                                  <li
                                    className={
                                      showIosDeviceType === 'old'
                                        ? 'active'
                                        : ''
                                    }
                                    onClick={() => setShowIosDeviceType('old')}>
                                    <span>1</span>
                                  </li>
                                  <li
                                    className={
                                      showIosDeviceType === 'new'
                                        ? 'active'
                                        : ''
                                    }
                                    onClick={() => setShowIosDeviceType('new')}>
                                    <span>2</span>
                                  </li>
                                  <li
                                    className={
                                      showIosDeviceType === 'ios17'
                                        ? 'active'
                                        : ''
                                    }
                                    onClick={() =>
                                      setShowIosDeviceType('ios17')
                                    }>
                                    <span>3</span>
                                  </li>
                                </ul>
                              )}
                            </div>
                            <div
                              className='mobile-wrapper ios'
                              id='ios'
                              style={{
                                display:
                                  showMobile === 'ios' &&
                                  showIosDeviceType === 'old'
                                    ? 'block'
                                    : 'none',
                              }}>
                              <div className='mobile-key silent'></div>
                              <div className='mobile-key volume-up'></div>
                              <div className='mobile-key volume-down'></div>
                              <div className='mobile-key power'></div>
                              <div
                                className='mobile-frame'
                                style={{
                                  backgroundSize: 'contain',
                                  backgroundImage: `url(${
                                    values.fullScreenUrl ||
                                    gradientDefaultRinger
                                  })`,
                                }}>
                                <div className='mobile-content'>
                                  <h4 className='name'>
                                    {/* {previewScreen.firstName}{' '}
                                {previewScreen.lastName} */}
                                    {`${values.prefixName}${
                                      values.isCheckMark ? CHECK_MARK : ''
                                    }${values.firstName}`}
                                  </h4>
                                  {/* <p className='number'>{previewScreen.phone}</p> */}
                                  <p className='number'>main</p>
                                </div>
                                {/* {values.logoUrl !== initialValues.logoUrl && (
                                  <img
                                    className='logo'
                                    src={values.logoUrl}
                                    alt='logo'
                                    srcset=''
                                  />
                                )} */}
                                {/* <div className='call-reason'>
                                  {values.callReason}
                                </div> */}
                                <div className='preview-screen-action'>
                                  <ul className='extra-content'>
                                    <li className='remind-me'>
                                      <a href='#!'>
                                        <svg
                                          xmlns='http://www.w3.org/2000/svg'
                                          className='ionicon'
                                          viewBox='0 0 512 512'>
                                          <path d='M153.59 110.46A21.41 21.41 0 00152.48 79 62.67 62.67 0 00112 64l-3.27.09h-.48C74.4 66.15 48 95.55 48.07 131c0 19 8 29.06 14.32 37.11a20.61 20.61 0 0014.7 7.8c.26 0 .7.05 2 .05a19.06 19.06 0 0013.75-5.89zM403.79 64.11l-3.27-.1H400a62.67 62.67 0 00-40.52 15 21.41 21.41 0 00-1.11 31.44l60.77 59.65a19.06 19.06 0 0013.79 5.9c1.28 0 1.72 0 2-.05a20.61 20.61 0 0014.69-7.8c6.36-8.05 14.28-18.08 14.32-37.11.06-35.49-26.34-64.89-60.15-66.93z' />
                                          <path d='M256.07 96c-97 0-176 78.95-176 176a175.23 175.23 0 0040.81 112.56l-36.12 36.13a16 16 0 1022.63 22.62l36.12-36.12a175.63 175.63 0 00225.12 0l36.13 36.12a16 16 0 1022.63-22.62l-36.13-36.13A175.17 175.17 0 00432.07 272c0-97-78.95-176-176-176zm16 176a16 16 0 01-16 16h-80a16 16 0 010-32h64v-96a16 16 0 0132 0z' />
                                        </svg>
                                        <span>Remind Me</span>
                                      </a>
                                    </li>
                                    <li className='remind-me'>
                                      <a href='#!'>
                                        <i className='fa fa-comment'></i>
                                        <span>Message</span>
                                      </a>
                                    </li>
                                  </ul>
                                  <ul className='phone-content'>
                                    <li className='call-icon decline'>
                                      <a href='#!'>
                                        <i className='fas fa-phone'></i>
                                      </a>
                                      <span className='desc'>Decline</span>
                                    </li>
                                    <li className='call-icon accept'>
                                      <a href='#!'>
                                        <i className='fas fa-phone'></i>
                                      </a>
                                      <span className='desc'>Accept</span>
                                    </li>
                                  </ul>
                                </div>
                                <div className='mobile-notch'>
                                  <div className='ear-speaker'></div>
                                  <div className='front-camera'></div>
                                </div>
                              </div>
                            </div>
                            <div
                              className='mobile-wrapper ios new-phone ios-full-control'
                              id='ios'
                              style={{
                                display:
                                  showMobile === 'ios' &&
                                  showIosDeviceType === 'new'
                                    ? 'block'
                                    : 'none',
                              }}>
                              <div className='mobile-key silent'></div>
                              <div className='mobile-key volume-up'></div>
                              <div className='mobile-key volume-down'></div>
                              <div className='mobile-key power'></div>
                              <div
                                className='mobile-frame'
                                style={{
                                  backgroundSize: 'contain',
                                  backgroundImage: `url(${
                                    values.fullScreenUrl ||
                                    gradientDefaultRinger
                                  })`,
                                }}>
                                <div className='mobile-content'>
                                  <h4 className='name'>
                                    {/* {values.firstName}{' '}
                                {values.lastName} */}
                                    {`${values.prefixName}${
                                      values.isCheckMark ? CHECK_MARK : ''
                                    }${values.firstName}`}
                                  </h4>
                                  {/* <p className='number'>{values.phone}</p> */}
                                  <p className='number'>main</p>
                                </div>
                                {/* {values.logoUrl !==
                                  initialPreviewScreen.logoUrl && (
                                  <img
                                    className='logo'
                                    src={values.logoUrl}
                                    alt='logo'
                                    srcset=''
                                  />
                                )}
                                <div className='call-reason'>
                                  {values.callReason}
                                </div> */}

                                <div className='preview-screen-action'>
                                  <ul className='extra-content'>
                                    <li className='remind-me'>
                                      <a href='#!'>
                                        <svg
                                          xmlns='http://www.w3.org/2000/svg'
                                          className='ionicon'
                                          viewBox='0 0 512 512'>
                                          <path d='M153.59 110.46A21.41 21.41 0 00152.48 79 62.67 62.67 0 00112 64l-3.27.09h-.48C74.4 66.15 48 95.55 48.07 131c0 19 8 29.06 14.32 37.11a20.61 20.61 0 0014.7 7.8c.26 0 .7.05 2 .05a19.06 19.06 0 0013.75-5.89zM403.79 64.11l-3.27-.1H400a62.67 62.67 0 00-40.52 15 21.41 21.41 0 00-1.11 31.44l60.77 59.65a19.06 19.06 0 0013.79 5.9c1.28 0 1.72 0 2-.05a20.61 20.61 0 0014.69-7.8c6.36-8.05 14.28-18.08 14.32-37.11.06-35.49-26.34-64.89-60.15-66.93z' />
                                          <path d='M256.07 96c-97 0-176 78.95-176 176a175.23 175.23 0 0040.81 112.56l-36.12 36.13a16 16 0 1022.63 22.62l36.12-36.12a175.63 175.63 0 00225.12 0l36.13 36.12a16 16 0 1022.63-22.62l-36.13-36.13A175.17 175.17 0 00432.07 272c0-97-78.95-176-176-176zm16 176a16 16 0 01-16 16h-80a16 16 0 010-32h64v-96a16 16 0 0132 0z' />
                                        </svg>
                                        <span>Remind Me</span>
                                      </a>
                                    </li>
                                    <li className='remind-me'>
                                      <a href='#!'>
                                        <i className='fa fa-comment'></i>
                                        <span>Message</span>
                                      </a>
                                    </li>
                                  </ul>
                                  <ul className='phone-content'>
                                    <li className='call-icon'>
                                      <a href='#!'>
                                        <i className='fas fa-phone'></i>
                                      </a>
                                    </li>
                                    <span className='msg'>slide to answer</span>
                                  </ul>
                                </div>
                                <div className='mobile-notch'>
                                  <div className='ear-speaker'></div>
                                  <div className='front-camera'></div>
                                </div>
                              </div>
                            </div>
                            <div
                              className='mobile-wrapper ios new-phone ios-full-control'
                              id='ios'
                              style={{
                                display:
                                  showMobile === 'ios' &&
                                  showIosDeviceType === 'ios17'
                                    ? 'block'
                                    : 'none',
                              }}>
                              <div className='mobile-key silent'></div>
                              <div className='mobile-key volume-up'></div>
                              <div className='mobile-key volume-down'></div>
                              <div className='mobile-key power'></div>
                              <div
                                className='mobile-frame'
                                style={{
                                  backgroundColor: 'gray',
                                  // backgroundSize: 'contain',
                                  // backgroundImage: `url(${
                                  //   values.fullScreenUrl ||
                                  //   gradientDefaultRinger
                                  // })`,
                                }}>
                                <div
                                  className='mobile-content'
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    textAlign: 'left',
                                    gap: 10,
                                    paddingLeft: '15px',
                                    paddingRight: '15px',
                                  }}>
                                  <img
                                    className='logo'
                                    src={values.logoUrl || defaultGallery}
                                    alt='logo'
                                    srcset=''
                                    width={40}
                                    height={40}
                                    style={{
                                      borderRadius: '999px',
                                    }}
                                  />
                                  <div
                                    style={{
                                      width: '100%',
                                    }}>
                                    <p className='number'>mobile</p>

                                    <h4 className='name'>
                                      {`${values.prefixName}${
                                        values.isCheckMark ? CHECK_MARK : ''
                                      }${values.firstName}`}
                                    </h4>
                                    {/* <p className='number'>{values.phone}</p> */}
                                  </div>
                                </div>
                                {/* {values.logoUrl !==
                                  initialPreviewScreen.logoUrl && (
                                  <img
                                    className='logo'
                                    src={values.logoUrl}
                                    alt='logo'
                                    srcset=''
                                  />
                                )}
                                <div className='call-reason'>
                                  {values.callReason}
                                </div> */}

                                <div className='preview-screen-action'>
                                  <ul className='extra-content'>
                                    <li className='remind-me'>
                                      <a href='#!'>
                                        <svg
                                          xmlns='http://www.w3.org/2000/svg'
                                          className='ionicon'
                                          viewBox='0 0 512 512'>
                                          <path d='M153.59 110.46A21.41 21.41 0 00152.48 79 62.67 62.67 0 00112 64l-3.27.09h-.48C74.4 66.15 48 95.55 48.07 131c0 19 8 29.06 14.32 37.11a20.61 20.61 0 0014.7 7.8c.26 0 .7.05 2 .05a19.06 19.06 0 0013.75-5.89zM403.79 64.11l-3.27-.1H400a62.67 62.67 0 00-40.52 15 21.41 21.41 0 00-1.11 31.44l60.77 59.65a19.06 19.06 0 0013.79 5.9c1.28 0 1.72 0 2-.05a20.61 20.61 0 0014.69-7.8c6.36-8.05 14.28-18.08 14.32-37.11.06-35.49-26.34-64.89-60.15-66.93z' />
                                          <path d='M256.07 96c-97 0-176 78.95-176 176a175.23 175.23 0 0040.81 112.56l-36.12 36.13a16 16 0 1022.63 22.62l36.12-36.12a175.63 175.63 0 00225.12 0l36.13 36.12a16 16 0 1022.63-22.62l-36.13-36.13A175.17 175.17 0 00432.07 272c0-97-78.95-176-176-176zm16 176a16 16 0 01-16 16h-80a16 16 0 010-32h64v-96a16 16 0 0132 0z' />
                                        </svg>
                                        <span>Remind Me</span>
                                      </a>
                                    </li>
                                    <li className='remind-me'>
                                      <a href='#!'>
                                        <i className='fa fa-comment'></i>
                                        <span>Message</span>
                                      </a>
                                    </li>
                                  </ul>
                                  <ul className='phone-content'>
                                    <li className='call-icon'>
                                      <a href='#!'>
                                        <i className='fas fa-phone'></i>
                                      </a>
                                    </li>
                                    <span className='msg'>slide to answer</span>
                                  </ul>
                                </div>
                                <div className='mobile-notch'>
                                  <div className='ear-speaker'></div>
                                  <div className='front-camera'></div>
                                </div>
                              </div>
                            </div>
                            <div
                              className='mobile-wrapper android'
                              id='android'
                              style={{
                                display:
                                  showMobile === 'android' ? 'block' : 'none',
                              }}>
                              <div className='mobile-key volume-up-down'></div>
                              <div className='mobile-key power'></div>
                              <div
                                className='mobile-frame'
                                style={{
                                  backgroundSize: 'contain',
                                  backgroundImage: `url(${
                                    values.fullScreenUrl ||
                                    gradientDefaultRinger
                                  })`,
                                }}>
                                <div className='mobile-content'>
                                  {/* <div className='call-title'>
                                <label>Dialing...</label>
                              </div> */}
                                  <h4 className='name'>
                                    {/* {values.firstName}{' '}
                                {values.lastName} */}
                                    {`${values.prefixName}${
                                      values.isCheckMark ? CHECK_MARK : ''
                                    }${values.firstName}`}
                                  </h4>
                                  <p className='number mobile-number'>
                                    {/* {values.phone
                                  .toString()
                                  .replace(/\D+/g, '')
                                  .replace(
                                    /(\d{3})(\d{3})(\d{4})/,
                                    '($1) $2-$3'
                                  )} */}
                                    {formatPhoneDisplay(
                                      Array.isArray(values.phone)
                                        ? values.phone[0]
                                        : values.phone
                                    )}
                                  </p>
                                </div>
                                {/* {values.logoUrl !==
                                  initialPreviewScreen.logoUrl && (
                                  <img
                                    className='logo'
                                    src={values.logoUrl}
                                    alt='logo'
                                    srcset=''
                                  />
                                )}
                                <div className='call-reason'>
                                  {values.callReason}
                                </div> */}
                                <div className='preview-screen-action'>
                                  <ul>
                                    <li className='call-icon start'>
                                      <a href='#!'>
                                        <i className='fas fa-phone-alt'></i>
                                      </a>
                                      {/* <span>Accept</span> */}
                                    </li>
                                    <li className='call-icon end'>
                                      <a href='#!'>
                                        <i className='fas fa-phone-alt'></i>
                                      </a>
                                      {/* <span>decline</span> */}
                                    </li>
                                  </ul>
                                </div>
                                <div className='mobile-notch'>
                                  {/* <div className='ear-speaker'></div> */}
                                  <div className='front-camera'></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <ImageEditorModal
                          galleryObject={galleryObject}
                          isOpenModal={editImageData.isOpen}
                          onHide={handleCloseEditImage}
                          imageUrl={editImageData.imageUrl}
                          type={editImageData.type}
                          imageId={editImageData.imageId}
                          isSaveAsNew
                          imageName={editImageData.name}
                          previewData={{
                            ...values,

                            currentGallery:
                              getImageUrl(values.galleryId) ||
                              gradientDefaultRinger,
                            currentGalleryCircle:
                              getImageUrl(values.circleGalleryId) ||
                              gradientDefaultRinger,
                          }}
                          onChange={(value) => {
                            if (editImageData.type) {
                              if (editImageData.type === 'logo') {
                                setFieldValue('logoUrl', value?.preview);
                                setFieldValue(`logoFile`, value);
                              } else {
                                setFieldValue('fullScreenUrl', value?.preview);
                                setFieldValue(`fullImageFile`, value);
                              }

                              // handleCloseEditImage();
                            }
                          }}
                          isOneTap={editImageData.isOneTap}
                        />
                        {isUploadImage && (
                          <>
                            <Modal
                              key='modal-upload'
                              size='sm'
                              show={isUploadImage}
                              onHide={() => setIsUploadImage(false)}
                              backdrop='static'
                              centered>
                              <Modal.Header closeButton>
                                <Modal.Title></Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                <>
                                  <div className='mydropzone-contactbtn'>
                                    <MyDropZoneLogo
                                      objectType={isUploadImage}
                                      onChange={(value) => {
                                        if (isUploadImage) {
                                          // if (isUploadImage === 'logo') {
                                          //   setFieldValue(
                                          //     'logoUrl',
                                          //     value?.preview
                                          //   );
                                          //   setFieldValue(`logoFile`, value);
                                          // } else {
                                          //   setFieldValue(
                                          //     'fullScreenUrl',
                                          //     value?.preview
                                          //   );
                                          //   setFieldValue(
                                          //     `fullImageFile`,
                                          //     value
                                          //   );
                                          // }

                                          // setFieldValue(
                                          //   `${isUploadImage}File`,
                                          //   value
                                          // );
                                          setIsUploadImage('');

                                          setEditImageData({
                                            type:
                                              isUploadImage === 'logo'
                                                ? 'logo'
                                                : 'fullscreen',
                                            isOpen: true,
                                            imageUrl: value?.preview || '',
                                            name: value?.name,
                                            isOneTap: isUploadImage === 'fullscreen' && isValidURL(values.linkActionUrl)
                                          });
                                        }
                                      }}
                                    />
                                    {/* </button> */}
                                    <button
                                      type='button'
                                      className='btn btn-primary mt-2'
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setShowGalleryModal(true);
                                      }}>
                                      Select From Gallery
                                    </button>
                                  </div>
                                </>
                              </Modal.Body>
                            </Modal>
                          </>
                        )}
                        <SelectGallery
                          setShowGalleryModal={setShowGalleryModal}
                          showGalleryModal={showGalleryModal}
                          logoType={isUploadImage}
                          onSelect={(galleryItem) => {
                            if (isUploadImage) {
                              console.log('isUploadImage', isUploadImage);
                              if (isUploadImage === 'logo') {
                                setFieldValue('logo', galleryItem.imageUrl);
                                setFieldValue('logoUrl', galleryItem.imageUrl);
                                setFieldValue(
                                  'circleGalleryId',
                                  galleryItem.galleryId
                                );
                              } else {
                                setFieldValue(
                                  'fullImage',
                                  galleryItem.imageUrl
                                );
                                setFieldValue(
                                  'fullScreenUrl',
                                  galleryItem.imageUrl
                                );
                                setFieldValue(
                                  'galleryId',
                                  galleryItem.galleryId
                                );
                              }

                              setFieldValue(`${isUploadImage}File`, null);

                              setIsUploadImage('');
                            }
                          }}
                        />
                      </div>
                    )}
                  </Formik>
                </Modal.Body>
              </Modal>

              {singleImageUrl && (
                <Lightbox
                  small={singleImageUrl}
                  large={singleImageUrl}
                  defaultValue={defaultGallery}
                  hideDownload={true}
                  hideZoom={true}
                  onError={(e) => {
                    e.target.src = defaultGallery;
                  }}
                  onClose={() => {
                    setSingleImageUrl('');
                  }}
                />
              )}

              <Modal
                size='sm'
                show={notifyAllMobileModal}
                onHide={() => setNotifyAllMobileModal(false)}
                backdrop='static'>
                <Modal.Header closeButton>
                  <Modal.Title>
                    <span style={{ fontSize: '18px' }}>Notify All Mobile</span>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className='notification-content-wrapper'>
                    <div className='mt-2 notification-type'>
                      <span>Type</span>
                      <div className='form-group'>
                        <input
                          type='radio'
                          name='notify-type'
                          value='silent'
                          checked={notificationDetails.silent}
                          onChange={(e) => {
                            e.target.value &&
                              setNotificationError({
                                ...notificationError,
                                type: '',
                              });
                            e.target.value === 'silent' &&
                              setNotificationDetails({
                                ...notificationDetails,
                                silent: true,
                              });
                          }}
                        />
                        <label className='ml-2' htmlFor='filter_1'>
                          Silent
                        </label>
                        <input
                          type='radio'
                          name='notify-type'
                          value='normal'
                          onChange={(e) => {
                            e.target.value &&
                              setNotificationError({
                                ...notificationError,
                                type: '',
                              });
                            e.target.value === 'normal' &&
                              setNotificationDetails({
                                ...notificationDetails,
                                silent: false,
                              });
                          }}
                        />
                        <label className='ml-2' htmlFor='filter_1'>
                          Normal
                        </label>
                      </div>
                      <span className='notification-error'>
                        {notificationError.type}
                      </span>
                    </div>
                    {!notificationDetails.silent && (
                      <div className='notification-title'>
                        <span>Title</span>
                        <input
                          className='form-control mt-1'
                          type='text'
                          placeholder='Enter title'
                          onChange={(e) => {
                            e.target.value &&
                              setNotificationError({
                                ...notificationError,
                                title: '',
                              });
                            setNotificationDetails({
                              ...notificationDetails,
                              title: e.target.value,
                            });
                          }}
                        />
                        <span className='notification-error'>
                          {notificationError.title}
                        </span>
                      </div>
                    )}
                    <button
                      type='button'
                      className='btn btn-primary mt-3'
                      onClick={() => notifyAllMobile()}>
                      Send
                    </button>
                  </div>
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </section>
      </div>

      {/* <Modal
        size='lg'
        show={isOpenImport}
        onHide={handleCloseModalImport}
        centered
        className='contact-update-modal'
        backdrop='static'>
        <Modal.Header closeButton>
          <Modal.Title>Import phone</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Card border='0' className='text-center pb-2' title='Upload File'>
            <div className='mb-2'>Maximum rows: 1.000</div>
            <div className='mb-2'>Please upload file in format: Sample.csv</div>
            <a className='mb-2' href='/Sample.csv' download>
              Download Example File
            </a>
            {isOpenImport && (
              <input
                value={null}
                style={{ display: 'none' }}
                id='upload-contact'
                type='file'
                onChange={changeFileHandler}
                accept='.csv'
              />
            )}
            <div>
              <Button style={{ padding: 0 }}>
                <label
                  style={{ padding: '10px', cursor: 'pointer' }}
                  htmlFor='upload-contact'>
                  Click to upload
                </label>
              </Button>
            </div>
          </Card>

          <div className='row'>
            <div>
              <div className='contact-data contact-data-table common-data-table'>
                <TableComponent
                  columns={columnsImport}
                  data={contactsImportData}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className='submit-button'>
            <Button
              
              variant='primary'
              className='d-flex align-items-center'>
              {isLoadingSubmitImport && (
                <Spinner
                  as='span'
                  animation='border'
                  size='sm'
                  role='status'
                  aria-hidden='true'
                />
              )}
              <span className='ps-1'>Submit data</span>
            </Button>
          </div>
        </Modal.Footer>
      </Modal> */}

      <Modal
        size='lg'
        show={isOpenImport}
        onHide={handleCloseModalImport}
        centered
        className='contact-update-modal'
        backdrop='static'>
        <Modal.Header closeButton>
          <Modal.Title>Import phone</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Card border='0' className='text-center pb-2' title='Upload File'>
            <div className='mb-2'>Maximum rows: 1.000</div>
            <div className='mb-2'>Please upload file in format: Sample.csv</div>
            <a className='mb-2' href='/Sample.csv' download>
              Download Example File
            </a>
            {/* <div>{codeNotExistMessageTemplate}</div> */}
            {isOpenImport && (
              <input
                value={null}
                style={{ display: 'none' }}
                id='upload-contact'
                type='file'
                onChange={changeFileHandler}
                accept='.csv'
              />
            )}
            <div>
              <Button style={{ padding: 0 }}>
                <label
                  style={{ padding: '10px', cursor: 'pointer' }}
                  htmlFor='upload-contact'>
                  Click to upload
                </label>
              </Button>
            </div>
          </Card>

          <div className='row'>
            <div>
              <div className='contact-data contact-data-table common-data-table'>
                <TableComponent
                  columns={columnsImport}
                  data={contactsImportData}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className='submit-button'>
            <Button
              disabled={disabledUpdateBtn || isLoadingSubmitImport}
              onClick={handleSubmitImportData}
              variant='primary'
              // isLoadingSubmitImport
              className='d-flex align-items-center'>
              {isLoadingSubmitImport && (
                <Spinner
                  as='span'
                  animation='border'
                  size='sm'
                  role='status'
                  aria-hidden='true'
                />
              )}
              <span className='ps-1'>Submit data</span>
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      </div>
      <FooterEnd />
    </div>
  );
};

const mapStateToProps = ({
  activeTabReducer: { showModal, modalAction },
  authReducer: { userRole, tenant },
}) => ({
  showModal: showModal,
  modalAction: modalAction,
  userRole: userRole,
  tenant: tenant,
});

const mapDispatchToProps = (dispatch) => ({
  setToaster: (data) => dispatch(showToast(data)),
  setShowModal: (data) => dispatch(setShowModal(data)),
  setModalAction: (data) => dispatch(setModalAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RCDContact);
